// Minimal, local helper: crops to a fixed rectangle (e.g., 468x200) and returns a data URL.
export async function cropImageToFixed(
  imageSrc: string,
  cropPx: { x: number; y: number; width: number; height: number } | null,
  opts: {
    width: number;
    height: number;
    format?: "image/jpeg" | "image/png" | "image/webp";
    quality?: number;     // only for jpeg/webp 
    background?: string;  // optional fill
  }
): Promise<string | null> {
  if (!cropPx) return null;

  const { width, height, format = "image/jpeg", quality = 0.92, background } = opts;

  const img = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  if (background) {
    ctx.fillStyle = background;
    ctx.fillRect(0, 0, width, height);
  }

  // Draw cropped source into fixed output size
  ctx.drawImage(
    img,
    cropPx.x, cropPx.y, cropPx.width, cropPx.height,
    0, 0, width, height
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (!blob) return resolve(null);
      const url = URL.createObjectURL(blob);
      resolve(url);
    }, format, quality);
  });
}

function createImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = (e) => reject(e);
    image.src = url;
  });
}
